export default "__VITE_ASSET__B6xrIga$__"